/* tslint:disable */
/* eslint-disable */
/**
 * Default API
 * All endpoints not defined under specific APIs
 *
 * The version of the OpenAPI document: Latest
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface LabelValuePair
 */
export interface LabelValuePair {
  /**
   *
   * @type {string}
   * @memberof LabelValuePair
   */
  label: string;
  /**
   *
   * @type {string}
   * @memberof LabelValuePair
   */
  value: string;
  /**
   *
   * @type {string}
   * @memberof LabelValuePair
   */
  helpText?: string | null;
  /**
   *
   * @type {Array<LabelValuePair>}
   * @memberof LabelValuePair
   */
  children?: Array<LabelValuePair>;
}

export function LabelValuePairFromJSON(json: any): LabelValuePair {
  return LabelValuePairFromJSONTyped(json, false);
}

export function LabelValuePairFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): LabelValuePair {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    label: json["label"],
    value: json["value"],
    helpText: !exists(json, "helpText") ? undefined : json["helpText"],
    children: !exists(json, "children")
      ? undefined
      : (json["children"] as Array<any>).map(LabelValuePairFromJSON),
  };
}

export function LabelValuePairToJSON(value?: LabelValuePair | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    label: value.label,
    value: value.value,
    helpText: value.helpText,
    children:
      value.children === undefined
        ? undefined
        : (value.children as Array<any>).map(LabelValuePairToJSON),
  };
}
